// AUTO GENERATED FILE - Changes WILL be lost.
// de-DE - used as 'de' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Wettschein",
  "product.last60-row-single": "NBA Letzte 60 Einzelspiele",
  "product.sb-english-single": "English Soccerbet Einzelspiel",
  "product.sb-italian-single": "Italienische Soccerbet Einzelspiel",
  "product.sb-greek-single": "Griechische Soccerbet Einzelspiel",
  "product.sb-english-league": "Englische Soccerbet Liga",
  "product.sb-italian-league": "Italienische Soccerbet Liga",
  "product.sb-greek-league": "Griechische Soccerbet Liga",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Wette platzieren",
  "betslip.clear": "Alle löschen",
  "betslip.clearResult": "Löschen",
  "betslip.noSelections": "Auswahlen hinzufügen, um mit dem Wetten zu beginnen",
  "betslip.notLoggedIn": "Anmelden, um mit dem Wetten zu beginnen",
  "betslip.refresh": "Aktualisieren",
  "betslip.totalStake": "Gesamteinsatz",
  "betslip.noHistoryData": "Keine Wettinformationen verfügbar",
  "betslip.openBets": "Offenen Wetten",
  "betslip.betHistory": "Wettverlauf",
  "betslip.betHistoryWon": "Gewonnen",
  "betslip.betHistoryLost": "Verloren",
  "loading.loading": "Wird geladen",
  "loading.account": "Konto wird geladen",
  "loading.league": "Liga wird geladen",
  "loading.gameweeks": "Spielwochen werden geladen",
  "loading.markets": "Märkte werden geladen",
  "loading.bethistory": "Wettverlauf wird geladen",
  "login.loginRequired": "Anmeldung nötig",
  "login.loginToBet": "Bitte anmelden, um mit dem Wetten zu beginnen",
  "navigation.back": "Zurück",
  "navigation.close": "Schließen",
  "video.liveStreamAvailable": "Live-Stream verfügbar",
  "video.logInToWatch": "Zum Anschauen bitte anmelden",
  "error.error": "Fehler",
  "error.404": "Seite nicht gefunden",
  "error.gameLaunchFailed": "Spiel konnte nicht geladen werden",
  "error.unknownErrorCode": "Unbekannter Fehler: {code}",
  "error.minUnitStakeLimitExceeded": "Mindesteinsatz beträgt {limit}",
  "error.maxUnitStakeLimitExceeded": "Maximaleinsatz beträgt {limit}",
  "error.minTotalStakeLimitExceeded": "Minimaler Gesamteinsatz beträgt {limit}",
  "error.maxTotalStakeLimitExceeded": "Maximaler Gesamteinsatz beträgt {limit}",
  "error.stakeInvalidMultiple": "Der Einsatz muss ein Vielfaches von {multiple} sein",
  "error.notPlaced": "Nicht platziert",
  "error.wagerDisallowed": "Einsatz nicht erlaubt",
  "error.errorEventIsOff": "Event hat begonnen",
  "wagerType.Singles": "Einzelwetten",
  "wagerType.Doubles": "Doppelwetten",
  "wagerType.Trebles": "Dreifachwetten",
  "wagerType.Accumulator": "Akkumulator",
  "wagerType.Perm 4-Folds": "4-fache Kombinationswette",
  "wagerType.Perm 5-Folds": "5-fache Kombinationswette",
  "wagerType.Perm 6-Folds": "6-fache Kombinationswette",
  "wagerType.Perm 7-Folds": "7-fache Kombinationswette",
  "wagerType.Perm 8-Folds": "8-fache Kombinationswette",
  "wagerType.Perm 9-Folds": "9-fache Kombinationswette",
  "error.excess_bets": "Maximal {limit} gleichzeitige Einsätze auf dem Wettschein; bitte entfernen Sie einen Einsatz",
  "product.sb-turkish-league": "Türkische Soccerbet Liga",
  "error.minBetslipLimitExceeded": "Mindestgesamteinsatz des Wettscheins ist {limit}",
  "error.maxBetslipLimitExceeded": "Der maximale Gesamteinsatz des Wettscheins beträgt {limit}",
  "error.exceededMaxPayout": "Die maximal mögliche Auszahlung beträgt {limit}; bitte reduzieren Sie Ihren Einsatz.",
  "betslip.potentialReturns": "Potenzielle Erträge",
  "betslip.taxDisclaimer": "Alle Ihre Nettogewinne werden bei Wettabrechnung versteuert. Der Steuerbetrag wird in Abhängigkeit vom möglichen Gewinn der Wette berechnet.",
  "error.maintenanceEnabled": "Der Server wird derzeit gewartet",
  "error.internalError": "Interner Fehler",
  "error.invalidSession": "Die Sitzung ist ungültig",
  "error.accountDisabled": "Konto ist deaktiviert",
  "error.invalidPlayerID": "Ungültige Spieler-ID",
  "error.insufficientBalance": "Unzureichendes Gleichgewicht",
  "error.configError": "Konfigurationsfehler",
  "error.betPlaceFailed": "Wette nicht platziert",
  "error.invalidProductID": "Ungültige Produkt-ID",
  "error.playerReachedGamingLimits": "Spieler hat die Grenzen des verantwortungsvollen Spielens erreicht",
  "error.gameCycleDoesNotExist": "Der Spielzyklus existiert nicht",
  "error.betAmountLimitExceeded": "Überschreitung des potenziellen Gewinnlimits für nicht verifizierte Spieler",
  "betslip.netStake": "Netto-Einsatz",
  "betslip.tax": "Steuer",
  "error.badReturns": "Die potenziellen Erträge sind niedriger als der Bruttoeinsatz",
  "betslip.taxDisclaimerPoland": "Bei Beträgen über 2.280 PLN werden die Gewinne um 10 % gekürzt.",
  "error.incompatibleVersion": "Nicht unterstützte Anwendungsversion. Bitte aktualisieren Sie.",
  "product.iihf-row-single": "IIHF Weltmeisterschaft",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Zurück zum Spieler",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Der durchschnittliche RTP für dieses Spiel ist {limit}",
  "error.betslipContainsInvalidOptions": "Wettschein enthält ungültige Optionen in rot",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Keine weiteren Wetten",
  "playtime": "Spielzeit",
  "gameId": "Spiel-ID",
  "noGames": "Es sind keine Spiele verfügbar. Schauen Sie bald zurück.",
  "Home": "Startseite",
  "Away": "Weg",
  "Visitor": "Besucher",
  "rules": "Regeln",
  "soccerbet.gameWeek": "SPIELWOCHE",
  "soccerbet.noGameWeeks": "Es sind keine Spielwochen verfügbar. Schauen Sie später noch einmal vorbei.",
  "soccerbet.league": "Liga-Tabelle",
  "soccerbet.table.name": "Namen",
  "soccerbet.table.won": "S",
  "soccerbet.table.drawn": "U",
  "soccerbet.table.lost": "N",
  "soccerbet.table.points": "PKT",
  "abbr.event.Both Teams To Score": "BTT",
  "event.Both Teams To Score": "Beide Teams treffen",
  "event.Over / Under": "Unter/Über",
  "event.Double Chance": "Doppelte Chance",
  "event.Match Result": "Spielergebnis",
  "event.Exact Goals": "Genaue Anzahl der Tore",
  "event.Correct Score": "Genaues Ergebnis",
  "event.Match Result Both Score": "Spielergebnis, Beide Teams treffen",
  "event.Result Und/Over 1.5 Total Goals": "Ergebnis, Über/Unter 1,5 Tore",
  "event.Result Und/Over 2.5 Total Goals": "Ergebnis, Über/Unter 2,5 Tore",
  "event.Under Over 1.5 Total Goals": "Über/Unter 1,5 Tore",
  "event.Under Over 2.5 Total Goals": "Über/Unter 2,5 Tore",
  "event.Under Over 3.5 Total Goals": "Über/Unter 3,5 Tore",
  "event.Under Over 4.5 Total Goals": "Über/Unter 4,5 Tore",
  "event.Total Goals 1 To 2": "Gesamttore 1 bis 2",
  "event.Total Goals 1 To 3": "Gesamttore 1 bis 3",
  "event.Total Goals 1 To 4": "Gesamttore 1 bis 4",
  "event.Total Goals 2 To 3": "Gesamttore 2 bis 3",
  "event.Total Goals 2 To 4": "Gesamttore 2 bis 4",
  "event.Under Over 1.5 Home Goals": "Über/Unter 1,5 Tore Heimmannschaft",
  "event.Under Over 1.5 Away Goals": "Über/Unter 1,5 Tore Auswärtsmannschaft",
  "event.Home Team Exact Goals": "Genaue Anzahl Tore Heimmannschaft",
  "event.Away Team Exact Goals": "Genaue Anzahl Tore Auswärtsmannschaft",
  "selection.Yes": "Ja",
  "selection.No": "Nein",
  "selection.1+G": "1+T",
  "selection.1+Ng": "1+KT",
  "selection.X+G": "X+T",
  "selection.X+Ng": "X+KT",
  "selection.2+G": "2+T",
  "selection.2+Ng": "2+KT",
  "selection.1+Yes": "1+Ja",
  "selection.1+No": "1+Nein",
  "selection.X+Yes": "X+Ja",
  "selection.X+No": "X+Nein",
  "selection.2+Yes": "2+Ja",
  "selection.2+No": "2+Nein",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "Ü",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "Über",
  "selection.Under": "Unter",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HUT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham F.",
  "abbr.sb-english.team.NOT": "NICHT"
}
